module.exports = __webpack_public_path__ + "img/2give.76cbd25b.svg";